import { z } from 'zod';
import { BookSchema, GlobalBookCornSchema } from '../../../base/books.js';
import { ContactSchema } from '../../../base/contacts.js';
export const GetGlobalBookRequestPathParametersSchema = z.object({
    bookId: GlobalBookCornSchema,
});
export const GetGlobalBookRequestSchema = GetGlobalBookRequestPathParametersSchema;
export const GetGlobalBookResponseSchema = BookSchema.extend({
    contacts: ContactSchema.array(),
});
export const GetGlobalBookApiSchema = {
    params: GetGlobalBookRequestPathParametersSchema,
    response: GetGlobalBookResponseSchema,
};
